/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { TypographyWrapper } from '@bwoty-web/ui-kit';

import SectionParagraph from '../../common/sectionParagraph';

import './sectionContentView.scss';

const SectionContentView = ({ content, isAppWebView = false }) => (
  <TypographyWrapper className={isAppWebView ? '' : 'uikit-box'}>
    {content?.body?.map(({ heading, paragraphs }) => (
      <div key={uniqid('section-content-')} className="gw-section-content">
        {heading && <h2 className="gw-section-content-heading">{heading}</h2>}
        {paragraphs.map((paragraph) => (
          <SectionParagraph
            key={uniqid('section-content-paragraph-')}
            paragraph={paragraph}
          />
        ))}
      </div>
    ))}
  </TypographyWrapper>
);

SectionContentView.propTypes = {
  content: PropTypes.shape({
    body: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        paragraphs: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
  }).isRequired,
  isAppWebView: PropTypes.bool,
};

export default SectionContentView;
